import script from "./dataselect.vue?vue&type=script&setup=true&lang=js"
export * from "./dataselect.vue?vue&type=script&setup=true&lang=js"

import "./dataselect.vue?vue&type=style&index=0&id=7bbf55c9&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bbf55c9"]])

export default __exports__